module.exports = __webpack_public_path__ + "static/media/intro-photowall-9.8e1fee8f.jpg";